module.exports = __webpack_public_path__ + "static/media/ovidiu_voicu.c0bce2d2.png";